import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=1a16e892"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a16e892')) {
      api.createRecord('1a16e892', component.options)
    } else {
      api.reload('1a16e892', component.options)
    }
    module.hot.accept("./Feed.vue?vue&type=template&id=1a16e892", function () {
      api.rerender('1a16e892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/Feed.vue"
export default component.exports